<template>
  <span
    :class="[
      'inline-flex items-center font-mono text-[10.5px] leading-none',
      'px-1.5 py-0.5 rounded border',
      toneClasses,
    ]"
  >
    <slot />
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tone: { type: String, default: 'neutral' }, // neutral | lime | warn | err | muted
});

const toneClasses = computed(() => ({
  neutral: 'bg-bg text-text-2 border-line-2',
  muted:   'bg-transparent text-text-3 border-line-2',
  lime:    'bg-[rgba(184,230,0,0.08)] text-lime border-[rgba(184,230,0,0.35)]',
  warn:    'bg-[rgba(245,165,36,0.08)] text-warn border-[rgba(245,165,36,0.35)]',
  err:     'bg-[rgba(240,82,82,0.08)] text-err border-[rgba(240,82,82,0.35)]',
}[props.tone]));
</script>
